import React from 'react';
import 'dayjs/locale/sv';
import { useIsMobile } from '../../helpers/customHooks';
import { FLAVOR } from '../../helpers/constants';

const DeviceInfoCardWIP = ({ spec, onClick, icon, value, label, danger = false, iconColor }) => {
    return(
        <>
            <div 
                onClick={spec ? (e) => onClick(e) : null} 
                className={`${spec ? "cursor-pointer" : ""} position-relative ${danger ? "bg-red-alt" : "bg-light-grey"} height80px border-12 d-flex flex-column justify-content-center align-items-center`}
            >
                <img src={icon} alt="" className={`size_15 position-absolute top-0 end-0 me-1 mt-1 ${iconColor ? iconColor : danger ? "white-white-icon" : "primary-icon"}`}/>
                <h4 className={`${danger ? "text-white": "primary"}`}>{value}</h4>
                <p className={`${danger ? "text-white": "primary"} thin  text-truncate`}>{label}</p>
            </div>
        </>
    )
}

export default DeviceInfoCardWIP;